import React, {Component} from 'react'
import './hotTopicList.css'
// import echarts from "echarts/lib/echarts";
import {Col, Row, Button} from "antd";
import {gethotworldRanking, gethotworldData} from "../actions"
import {uuid} from "../utils";


class HotTopicList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rankdata: [],
            hotworld: [],
            backgroudColer:'#40A9FF',

        }
    }

    componentDidMount() {
        //获取排行榜数据
        gethotworldRanking('month',this.updateRankData.bind(this));

        //获取热词
        // gethotworldData(this.updateHotWorldData.bind(this));
    }

    //点击按钮事件
    onClickWeek(time){
        this.setState({
                    backgroudColer:'',
                })

        gethotworldRanking(time,this.updateRankData.bind(this));
    }

     updateRankData(randData) {
        if(!randData || randData.length === 0){
            return;
        }
        //计算出前三名占总数的百分比；
        var allNumber = 0;
        var index = 1;
        randData&&randData.length&&randData.map((el) => {
            el.index = index;
            if (index < 4) {
                allNumber += el.viewNum;
            }
            index++;
        })

        if(randData[0]){
            randData[0].width = (randData[0].viewNum / allNumber) * 100 + '%';
        }
        if(randData[1]){
            randData[1].width = (randData[1].viewNum / allNumber) * 100 + '%';
        }if(randData[2]){
            randData[2].width = (randData[2].viewNum / allNumber) * 100 + '%';
        }

        this.setState({
            rankdata: randData
        },()=>{

        });
    }

    updateHotWorldData(hotworld) {
        var hotworlds = [];
        hotworld.map((el) => {
            hotworlds.push(el.word)
        })

        this.setState({
            hotworld: hotworlds
        });
    }

    render() {
        return <div className='hotTopicList'>
            <Row>
                <Col span={16} xs={16} md={16} xxl={16}>
                    <div className='hotTopictitle'>
                        热文排行
                    </div>
                </Col>
                {/*<Col span={8} xs={8} md={8} xxl={8}>*/}
                {/*    <Button type="primary" size='small' className='hotworlbutton'*/}
                {/*            onClick={() => {*/}
                {/*                this.onClickWeek('week');*/}
                {/*            }}*/}
                {/*    >近7天</Button>*/}
                {/*    <Button type="primary" size='small' className='hotworlbutton'*/}
                {/*            style={{backgroundColor: this.state.backgroudColer}}*/}
                {/*            onClick={() => {*/}
                {/*                this.onClickWeek('month');*/}

                {/*            }}*/}
                {/*    >近30天</Button>*/}
                {/*</Col>*/}
            </Row>
            <Row>
                <div className='gridhead'>
                    <Col span={18} xs={18} md={18} xxl={18}>
                        <div className='gridheadtitle biaoti'>
                            标题
                        </div>
                    </Col>
                    <Col span={6} xs={6} md={6} xxl={6}>
                        <div className='gridheadreadCount'>阅读量</div>
                    </Col>
                </div>
            </Row>
            <Row>
                <Col span={24} xs={24} md={24} xxl={24}>
                    {
                        this.state.rankdata&& this.state.rankdata.length&&this.state.rankdata.map((el) => <ColorProcess key={uuid()} data={el}/>)
                    }
                    {/*<ProcessGrid data={this.state.rankdata}/>*/}
                </Col>
            </Row>
            {/*<Row className="hotworld">*/}
            {/*    <Col span={24} xs={24} md={24} xxl={24}>*/}
            {/*        <ul className='hotWorld-ul'>*/}
            {/*            <HotWorld data={this.state.hotworld}/>*/}
            {/*        </ul>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
        </div>
    }
}

function ColorProcess(props) {
    let datas = props.data;
    let style = null;
    let index = datas.index;
    let fontStyle = null;
    if (index < 4) {
        fontStyle = {
            fontStyle: "italic",
            fontSize: "20px",
            color: "white"
        }
    } else {
        fontStyle = {
            fontStyle: "italic",
            textAlign: 'center',
            color: "white",
            width: "19px",
            height: "19px",
            lineHeight:'19px',
            display: 'inline-block',
            borderRadius: '10px',
            backgroundColor: '#D2DFEF'
        }

    }
    switch (index) {
        case 1:
            style = {
                width: datas.width,
                height: '30px',
                background: '#B3D3F9',
                position: 'absolute',
                // display: 'block'
                top: '6px',
            }
            break;
        case 2:
            style = {
                width: datas.width,
                height: '30px',
                background: '#D2E7FC',
                position: 'absolute',
                // display: 'block'
                top: '6px',

            }
            break;
        case 3:
            style = {
                width: datas.width,
                height: '30px',
                background: '#E7F1FD',
                position: 'absolute',
                // display: 'block'
                top: '6px',

            }
            break;
        default:
            style = {};

    }
    return <Row className="gutter-row">
        <div className='gridheadContent'>
            <Col span={19} xs={19} md={19} xxl={19} style={{position: 'relative'}}>
                {/*<div className='gridheadtitle'>*/}
                {/*    <span style={fontStyle}>{datas.index}</span><span style={{paddingLeft:'15px'}}>{datas.title}</span>*/}
                {/*</div>*/}
                {/*<div className='gridheadtitle2' style={style}>*/}
                {/*</div>*/}
                <List fontStyle={fontStyle} index={datas.index} title={datas.title} style={style}></List>
            </Col>
            <Col span={5} xs={5} md={5} xxl={5}>
                <div className='gridheadreadCount'>{datas.total}</div>
            </Col>
        </div>
    </Row>;

}

class List extends React.Component {

    state = {
        maxWidth: this.props.style.width ? parseInt(this.props.style.width) : 0,
        width: this.props.style.width ? parseInt(this.props.style.width) : 0
    }

    timer = null;
    speed = 10;

    mouseOver() {
        if (this.state.maxWidth !== 0) {
            let that = this;
            this.setState({
                width: 0
            })
            this.timer = setInterval(function () {
                that.setState(prevState => {
                    let newWidth = prevState.width;
                    if (newWidth >= 0 && newWidth < prevState.maxWidth) {
                        newWidth++;
                    } else {
                        clearInterval(that.timer);
                    }
                    return {
                        width: newWidth
                    }
                })
            }, this.speed);
        }
    }

    mouseOut() {
        if (this.state.maxWidth !== 0) {
            this.setState({
                width: this.state.maxWidth
            })
        }
        if (this.timer != null)
            clearInterval(this.timer);
    }

    render() {
        let _style = Object.assign({}, this.props.style);
        _style.width = this.state.width + "%";

        return <div onMouseOver={() => this.mouseOver()} onMouseOut={() => this.mouseOut()}>
            <div className={'gridheadtitle'}>
                <span style={this.props.fontStyle}>{this.props.index}</span>
                <span style={{paddingLeft: this.props.index <4 ? '22px':'15px'}} title={this.props.title}>{this.props.title}</span>
            </div>
            <div className='gridheadtitle2' style={_style}>
                {/*{datas.index}{datas.title}*/}
            </div>
        </div>
    }
}

function ProcessGrid(props) {
    var ListView = [];
    var data = props.data;
    data.map((el) => {
        ListView.push(<ColorProcess data={el}></ColorProcess>)
    })

    return ListView;
}


/**
 * 热词组件
 * @param props
 * @returns {[]}
 * @constructor
 */
function HotWorld(props) {

    var ListView = [];
    var data = props.data;
    let hotstyle = {
        float: 'left',
        // backgroundImage: 'url("/images/hotworld.png")',
        backgroundColor: '#6BADF3',
        paddingLeft: '10px',
        paddingRight: '10px',
        paddingTop: '2px',
        paddingBottom: '2px',
        fontsize: "16px",
        color: "#F5F8FD",
        textAlign: "center",
        image: {
            height: "100%"
        },
        listStyle:'none'
    };
    let commonstyle = {
        float: 'left',
        background: '#F5F8FD',
        marginLeft: '5px',
        paddingLeft: '15px',
        paddingRight: '15px',
        paddingTop: '5px',
        paddingBottom: '5px',
        listStyle:'none'

    };
    ListView.push(<li className='hotWorld-li' key={uuid()} style={hotstyle}><img src='images/hotworld.png'></img> 热门词</li>)
    data.map((el) => {
        ListView.push(<li key={uuid()} style={commonstyle}>{el}</li>)
    })

    return ListView;

}

export default HotTopicList;


